module.exports = __webpack_public_path__ + "static/img/home_qr@2x.e6f7982.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home_qr@2x.png
// module id = o2L5
// module chunks = 0